import { Outlet } from 'react-router';
import { usePageViews } from '@/lib/analytics';

/** The router root: every route, the landing page included, reports its page view from here (TW-7). */
export function PageViews() {
  usePageViews();
  return <Outlet />;
}
